import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import EnhancedScenarioManager from '../../../components/ScenarioManagement/EnhancedScenarioManager';

const ScenarioLibrary: React.FC = () => {
  const [mode, setMode] = useState<'list' | 'create' | 'edit'>('list');
  const [selectedScenarioId, setSelectedScenarioId] = useState<string>();

  const handleModeChange = (newMode: 'list' | 'create' | 'edit', scenarioId?: string) => {
    setMode(newMode);
    setSelectedScenarioId(scenarioId);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-navy-950 to-navy-900 py-8 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Navigation */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex items-center justify-between mb-8"
        >
          <div className="flex items-center gap-4">
            <Link
              to="/manage"
              className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors duration-200"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              Back to Dashboard
            </Link>
            <span className="text-slate-500">|</span>
            <h1 className="text-3xl font-light text-white">
              Scenario Library
            </h1>
          </div>
          <Link
            to="/"
            className="text-slate-300 hover:text-white transition-colors duration-200"
          >
            ← Back to Game
          </Link>
        </motion.div>

        {/* Enhanced Scenario Manager */}
        <EnhancedScenarioManager
          mode={mode}
          scenarioId={selectedScenarioId}
          onModeChange={handleModeChange}
        />
      </div>
    </div>
  );
};

export default ScenarioLibrary;